export default "__VITE_ASSET__DKMDcTCt__"